import PropTypes from 'prop-types';
import React from 'react';
import styled from 'styled-components';
import { Container, H1, P, Section } from 'styleguide';

const TextWrapper = styled.div`
  max-width: 410px;
  margin: 0 auto;
`;

export const StyledContainer = styled(Container)`
  height: 100%;
  padding: 50px;
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const Title = styled(H1)`
  line-height: 2em;
  margin: 0;
`;

export const EmptyState = ({ imageURL, text, cta, heading, fullWidth }) => (
  <StyledContainer data-cy="empty-state" fullWidth={fullWidth}>
    <Section align="center" size="lg">
      <img src={imageURL} alt="Empty state placeholder" />
      <Section>
        <Title>{heading}</Title>
        <TextWrapper>
          <P>{text}</P>
        </TextWrapper>
      </Section>
      <Section css={{ display: 'inline-block' }}>{cta}</Section>
    </Section>
  </StyledContainer>
);

EmptyState.propTypes = {
  imageURL: PropTypes.string.isRequired,
  text: PropTypes.string.isRequired,
  heading: PropTypes.string.isRequired,
  fullWidth: PropTypes.bool,
  cta: PropTypes.node,
};

export default EmptyState;
